var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phosphor Icons/ ChatCircleDots "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6745 5.04692C14.0033 4.87951 11.3628 5.69289 9.24874 7.33436C7.1347 8.97583 5.6925 11.3325 5.1929 13.9619C4.6933 16.5914 5.17065 19.3128 6.53534 21.6152C6.67509 21.851 6.71194 22.1338 6.63727 22.3975L5.46607 26.5341L9.60267 25.3629L9.8751 26.3251L10.385 25.4649C12.6874 26.8295 15.4088 27.3069 18.0382 26.8073C20.6677 26.3077 23.0244 24.8655 24.6658 22.7515C26.3073 20.6374 27.1207 17.9969 26.9533 15.3257C26.7859 12.6544 25.6492 10.1361 23.7566 8.24357C21.8641 6.35101 19.3458 5.21433 16.6745 5.04692ZM9.74421 27.4015C12.3827 28.8479 15.4466 29.3355 18.4116 28.7721C21.5196 28.1816 24.3053 26.4769 26.2455 23.978C28.1858 21.4792 29.1472 18.3581 28.9494 15.2006C28.7515 12.0431 27.4079 9.06641 25.1708 6.82936C22.9338 4.5923 19.9571 3.24871 16.7996 3.05084C13.6421 2.85296 10.521 3.81439 8.02216 5.75465C5.52331 7.69491 3.8186 10.4805 3.22806 13.5886C2.6647 16.5536 3.15225 19.6175 4.59873 22.256L3.53889 25.9993C3.44016 26.34 3.43445 26.7011 3.52239 27.0448C3.61075 27.3903 3.7904 27.7056 4.04251 27.9577C4.29463 28.2098 4.60993 28.3894 4.95535 28.4778C5.29915 28.5657 5.66019 28.56 6.00099 28.4613L9.74421 27.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 17.5C10.8284 17.5 11.5 16.8284 11.5 16C11.5 15.1716 10.8284 14.5 10 14.5C9.17157 14.5 8.5 15.1716 8.5 16C8.5 16.8284 9.17157 17.5 10 17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22 17.5C22.8284 17.5 23.5 16.8284 23.5 16C23.5 15.1716 22.8284 14.5 22 14.5C21.1716 14.5 20.5 15.1716 20.5 16C20.5 16.8284 21.1716 17.5 22 17.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon_chat.c62830a59c47b858757a35e6fd8efea7.svg";
export { ForwardRef as ReactComponent };